import { sosHttpInstance } from './httpClient';
import { METADATA_ENDPOINTS, ALERT_ENDPOINTS } from '@/constants/apiEndpoints';

export const fetchFiltersApi = async () => {
  const response = await sosHttpInstance.get(METADATA_ENDPOINTS.FILTER_DATA);
  return response.data.ALERT_PAGE;
};

// SOS: Fetch Alert & Resource Data Flow (Sequence Diagram JSON)
export const fetchSOSDataFlowDetailsApi = async (body) => {
  try {
    const { data } = await sosHttpInstance.post(
      ALERT_ENDPOINTS.DATA_FLOW,
      body,
    );

    return data;
  } catch (error) {
    return {
      success: false,
      error: true,
      data: error?.response?.data || { message: 'Unknown error occurred' },
    };
  }
};
